import React from 'react';

type Props = {
  children: React.ReactNode;
  className?: string;
};

export const FrontDrawerPanel: React.FC<Props> = ({ children, className = '' }) => (
  <div
    className={`ips-frontfw-overlay__panel ips-frontfw-overlay__panel--drawer ${className}`.trim()}
    role="dialog"
    aria-modal="true"
  >
    {children}
  </div>
);
